module.exports = __webpack_public_path__ + "static/media/trash.b5426265.svg";